import { Component } from "@angular/core";

@Component({
  selector: "group-widget",
  templateUrl: "./group-widget.component.html",
  styleUrls: ["./group-widget.component.scss"],
})
export class GroupWidgetComponent {}
